// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"c89391d7","453":"9d4fd6e7"}[chunkId] + ".chunk.js";
};